import React, { PureComponent } from 'react';

import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import { BaseColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';
import {
  CardAnalythic,
  SubtitleCard,
  SubtitleSemiBold,
  ContainerGray,
  AnalythicList,
  AnalythicLine,
  LineTitle,
  RecommendationBox,
  RecommendationText,
  RecommendationsColumn,
  IconRecommendation,
  SpanRecommendation,
  OtherDataList
} from '../analythic.styled';

import { getLocationChecked } from './products/fcAnalise';
import Location from '@bit/wavfichacerta.fichacerta.icons.location';
import ReportRecommendation from '@bit/wavfichacerta.fichacerta.icons.report-recommendation';

import ReactTooltip from 'react-tooltip'
import TourTooltip from '../../../shared/TourTooltip';

export default class LocationSection extends PureComponent {

  renderDataLine = (title, data) => (
    <AnalythicLine key={(title + data)} style={{display: 'inline-flex', width: '100%', color: '#000'}}>
      <LineTitle maxWidth="25%" style={{flex: '0 0 25%'}}>{title}</LineTitle>
      <span data-testid={title}>{data}</span>
    </AnalythicLine>
  )

  renderOtherAddresses = (title, data) => (
    <AnalythicLine key={(title + data)} style={{display: 'inline-flex', width: '100%', color: '#000'}}>
      <LineTitle maxWidth="25%" style={{flex: '0 0 25%'}}>{title}</LineTitle>
      <span data-testid={title}>
        <OtherDataList>{data.map((address) => <li>{address}</li>)}</OtherDataList>
      </span>
    </AnalythicLine>
  )

  renderDataChecked = () => {
    let dataChecked = getLocationChecked(this.props.data);
    const productFcReport = this.props.data.pretendente.produtos.ativo.filter(product => product.id === 1 && product.status !== 'INCLUIDO')
    const productFcRenda = this.props.data.pretendente.produtos.ativo.filter(product => product.id === 2)
    const productFcEssencial = this.props.data.pretendente.produtos.ativo.filter(product => product.id === 3 && product.status !== 'INCLUIDO')
    const productFcEmpresa = this.props.data.pretendente.produtos.ativo.filter(product => product.id === 4)
    const productFcBasico = this.props.data.pretendente.produtos.ativo.filter(product => product.id === 5)
    if(productFcBasico.length && !productFcEssencial.length && !productFcReport.length) {
      dataChecked = getLocationChecked(this.props.data, 'fcBasico');
    }
    return dataChecked.map((line) => {
      if (line.key === 'otherAddress' && Array.isArray(line.data)) {
        return this.renderOtherAddresses(line.title, line.data);
      }
      return this.renderDataLine(line.title, line.data);
    });
  }

  getRecommendations = () => {
    const { data } = this.props;

    if (data !== undefined && data !== null && (typeof data === "object" && Object.keys(data).length > 0)) {
      const searchKeys = ["veracidade_endereco", "veracidade_telefone", "veracidade_celular", "veracidade_email"];
      const { laudo } = data;
      let recommendations = [];
      searchKeys.forEach((key) => {
        if (laudo[key] !== undefined && laudo[key] !== null) {
          recommendations = [...recommendations, ...laudo[key].recommendation];
        }
      });

      if (Array.isArray(recommendations) && recommendations.length > 0) {
        // Remove duplicates
        recommendations = recommendations.filter((rec, index) => recommendations.indexOf(rec) === index);
        return (
          <RecommendationBox>
            <BaseColumn xs={12} md={1} lg={1} xl={1}>
              <RecommendationText>Obs: </RecommendationText>
            </BaseColumn>
            <RecommendationsColumn xs={12} md={11} lg={11} xl={11}>
              {recommendations.map((item) => (
                <RecommendationText>
                  <IconRecommendation><ReportRecommendation /></IconRecommendation>
                  <SpanRecommendation>{item}</SpanRecommendation>
                </RecommendationText>
              ))}
            </RecommendationsColumn>
          </RecommendationBox>
        );
      }
    }
    return null;
  }

  renderResultFcRenda = (result) => {
    const { data } = this.props;
    const fcDoc = 'produtos' in data.laudo ? data.laudo.produtos.fcrenda : {};
    if(!fcDoc.resultado || !fcDoc.confirmacao_endereco || !fcDoc.ativo) {
      return null;
    }

    return(
      <div style={{border: '2px solid #152b4e', padding: '4px 10px', color: '#152b4e', fontSize: 12, marginTop: 6, width: '100%', fontWeight: 'bolder'}} className='result-fcdoc'>
        {fcDoc.confirmacao_endereco}
      </div>
    )
  }

  render() {
    const { data } = this.props;
    const fcDoc = data.laudo.produtos.fcrenda;
    return (
      <CardAnalythic
        title="DADOS DE LOCALIZAÇÃO (encontrados)"
        iconHeader={Location}
        iconLeft={true}
      >
        {fcDoc.ativo === true && fcDoc.resultado && fcDoc.confirmacao_endereco &&
          <span className='font-13-print' style={{backgroundColor: '#152b4e', color: '#fff', fontWeight: 600, padding: '2px 6px', marginLeft: 4, position: 'absolute', top: 12, left: 402}}>
            FC DOC
          </span>
        }
        <StyledRow margin=".5rem 0 0 0" className="font-13-print">
          <BaseColumn md={12} lg={12} xs={12}>
            <ContainerGray data-testid="dadosLocalizacao">
              {/* <SubtitleCard>DADOS DE LOCALIZAÇÃO <SubtitleSemiBold>ENCONTRADOS</SubtitleSemiBold></SubtitleCard> */}
              <AnalythicList style={{display: 'block', columnCount: 2, columnGap: '0.4rem'}}>
                {this.renderDataChecked()}
              </AnalythicList>
            </ContainerGray>
          </BaseColumn>
          {this.renderResultFcRenda()}
        </StyledRow>
        {/* <TourTooltip
          target="tooltip-dados-pessoais"
          style={{right: -3, top: -17}}
        />
        <ReactTooltip id="tooltip-dados-pessoais" place="left" type="dark" effect="float">
          <span>Nesta área te entregamos dados pessoais, possíveis endereços, e telefones.</span>
        </ReactTooltip> */}
      </CardAnalythic>
    );
  }
}
